import React from 'react'

function Industries() {
    return (
        <>
            {/* Industries We Serve Section */}
            <section className="industries-section py-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 className="display-5 fw-bold text-white mb-3">
                            Industries We Serve
                        </h2>
                        <p className="text-muted lead mx-auto">
                            Delivering innovative technology solutions across diverse sectors with deep industry expertise and proven track record
                        </p>
                    </div>

                    <div className="hexagon-container">
                        <div className="hexagon-grid">
                            {/* Industry 1 - Petrochemicals */}
                            <div className="hexagon-wrapper" data-industry="petrochemicals">
                                <div className="hexagon">
                                    <div className="hexagon-content">
                                        <div className="industry-image" style={{
                                            backgroundImage: 'url(https://www.cloudmind.ae/static/media/healthcare.3c7f052d595eddc199a8.webp)'
                                        }}></div>
                                        <div className="industry-overlay">
                                            <h3 className="industry-title">HEALTHCARE</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Industry 2 - Steel Plants */}
                            <div className="hexagon-wrapper" data-industry="steel">
                                <div className="hexagon">
                                    <div className="hexagon-content">
                                        <div className="industry-image" style={{
                                            backgroundImage: 'url(https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=800&q=80)'
                                        }}></div>
                                        <div className="industry-overlay">
                                            <h3 className="industry-title">BANKING</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Industry 3 - Power Plants */}
                            <div className="hexagon-wrapper" data-industry="power">
                                <div className="hexagon">
                                    <div className="hexagon-content">
                                        <div className="industry-image" style={{
                                            backgroundImage: 'url(https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=800&q=80)'
                                        }}></div>
                                        <div className="industry-overlay">
                                            <h3 className="industry-title">TRAVEL</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Industry 4 - Chemical */}
                            <div className="hexagon-wrapper" data-industry="chemical">
                                <div className="hexagon">
                                    <div className="hexagon-content">
                                        <div className="industry-image" style={{
                                            backgroundImage: 'url(https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?w=800&q=80)'
                                        }}></div>
                                        <div className="industry-overlay">
                                            <h3 className="industry-title">MANUFACTURING</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Industry 5 - Oil Refineries */}
                            <div className="hexagon-wrapper" data-industry="oil">
                                <div className="hexagon">
                                    <div className="hexagon-content">
                                        <div className="industry-image" style={{
                                            backgroundImage: 'url(https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=800&q=80)'
                                        }}></div>
                                        <div className="industry-overlay">
                                            <h3 className="industry-title">RETAIL</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Industry 6 - Cement Units */}
                            <div className="hexagon-wrapper" data-industry="cement">
                                <div className="hexagon">
                                    <div className="hexagon-content">
                                        <div className="industry-image" style={{
                                            backgroundImage: 'url(https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=800&q=80)'
                                        }}></div>
                                        <div className="industry-overlay">
                                            <h3 className="industry-title">EDUCATION</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Industry 7 - Fertilizer */}
                            <div className="hexagon-wrapper" data-industry="fertilizer">
                                <div className="hexagon">
                                    <div className="hexagon-content">
                                        <div className="industry-image" style={{
                                            backgroundImage: 'url(https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=800&q=80)'
                                        }}></div>
                                        <div className="industry-overlay">
                                            <h3 className="industry-title">REAL ESTATE</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Industry 8 - Hotels */}
                            <div className="hexagon-wrapper" data-industry="hotels">
                                <div className="hexagon">
                                    <div className="hexagon-content">
                                        <div className="industry-image" style={{
                                            backgroundImage: 'url(https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80)'
                                        }}></div>
                                        <div className="industry-overlay">
                                            <h3 className="industry-title">TRANSPORTATION</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Industry 9 - Glass Industry */}
                            <div className="hexagon-wrapper" data-industry="glass">
                                <div className="hexagon">
                                    <div className="hexagon-content">
                                        <div className="industry-image" style={{
                                            backgroundImage: 'url(https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=800&q=80)'
                                        }}></div>
                                        <div className="industry-overlay">
                                            <h3 className="industry-title">TELECOM</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Industry 10 - Textile Industry */}
                            <div className="hexagon-wrapper" data-industry="textile">
                                <div className="hexagon">
                                    <div className="hexagon-content">
                                        <div className="industry-image" style={{
                                            backgroundImage: 'url(https://www.cloudmind.ae/static/media/social.60abd97c17cab40d3901.webp)'
                                        }}></div>
                                        <div className="industry-overlay">
                                            <h3 className="industry-title">MEDIA & ADEVERTISING</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Industry 11 - Hospitals */}
                            <div className="hexagon-wrapper" data-industry="hospitals">
                                <div className="hexagon">
                                    <div className="hexagon-content">
                                        <div className="industry-image" style={{
                                            backgroundImage: 'url(https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=800&q=80)'
                                        }}></div>
                                        <div className="industry-overlay">
                                            <h3 className="industry-title">AGRICULTURE</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Industry 12 - Airports */}
                            <div className="hexagon-wrapper" data-industry="airports">
                                <div className="hexagon">
                                    <div className="hexagon-content">
                                        <div className="industry-image" style={{
                                            backgroundImage: 'url(https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=800&q=80)'
                                        }}></div>
                                        <div className="industry-overlay">
                                            <h3 className="industry-title">GOVERNMENT</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Industries